'use client';

import { usePathname, useSearchParams } from 'next/navigation';
import { useEffect, useRef } from 'react';
import useSessionStorage, {
  SessionStorageKey,
} from '@/libraries/hooks/use-session-storage';

/**
 * A render-less client component that tracks the **previous** page URL
 * across Next.js client-side navigation and persists it to
 * `sessionStorage` under the key `previousPageUrl`.
 */

const NavigationTracker = () => {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const [, setPreviousPageUrl] = useSessionStorage<string>(
    SessionStorageKey.PREVIOUS_PAGE_URL,
  );

  const previousUrlRef = useRef<string | null>(null);

  const currentUrl = searchParams?.toString()
    ? `${pathname}?${searchParams.toString()}`
    : pathname;

  useEffect(() => {
    if (previousUrlRef.current !== null) {
      setPreviousPageUrl(previousUrlRef.current);
    }

    previousUrlRef.current = currentUrl;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUrl]);

  return null;
};

NavigationTracker.displayName = 'NavigationTracker';

export default NavigationTracker;
